(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoDeleteController',SSPeriodoDeleteController);

    SSPeriodoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSPeriodo'];

    function SSPeriodoDeleteController($uibModalInstance, entity, SSPeriodo) {
        var vm = this;

        vm.sSPeriodo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSPeriodo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
